import { t } from '@avalara/bat-apps-shared/i18n';

const ExistingPaymentMethodNotice = () => (
  <p className='margin-bottom-md'>{t('client.general.your-existing-payment-method-on-file-will-be-used')}</p>
);

export default ExistingPaymentMethodNotice;
